import React from "react";
import LoginForm from "../../components/auth/LoginForm";

const AdminLogin = () => {
    return <LoginForm role="admin" title="Administrator Portal" showRegisterLink={false} />;
};

export default AdminLogin;
